import { Routes } from "@angular/router";

import {BlankLayoutComponent} from "./components/common/layouts/blankLayout.component";
import { BasicLayoutComponent } from "./components/common/layouts/basicLayout.component";
import {AuthenticationGuard} from "./authentication.guard";
// import { RegistryListComponent } from './pages/registry-list/registry-list.component';
// import { GroupComponent } from './pages/group/group.component';
// import { GroupDetailsComponent } from './pages/group-details/group-details.component';
// import {TopNavigationLayoutComponent} from "./components/common/layouts/topNavigationlayout.component";

export const ROUTES: Routes = [
    // Main redirect
    {path: '', redirectTo: '/login', pathMatch: 'full'},
    {
        path: 'pages', component: BasicLayoutComponent,
        children: [
            { path: 'dashboard', loadChildren: './pages/dashboard/dashboard.module#DashboardModule', canActivate: [AuthenticationGuard] },
            { path: 'archived-tasks', loadChildren: './pages/archived-tasks/archived-tasks.module#ArchivedTasksModule', canActivate: [AuthenticationGuard] },
            { path: 'events', loadChildren: './pages/events/events.module#EventsModule', canActivate: [AuthenticationGuard] },
            { path: 'events/:id', loadChildren: './pages/events/events.module#EventsModule', canActivate: [AuthenticationGuard] },
            { path: 'container', loadChildren: './pages/container/container.module#ContainerModule', canActivate: [AuthenticationGuard] },
            { path: 'infrastructure', loadChildren: './pages/infra/infrastructure.module#InfrastructureModule', canActivate: [AuthenticationGuard] },
            { path: 'metrics', loadChildren: './pages/metrics/metrics.module#MetricsModule', canActivate: [AuthenticationGuard] },
            { path: 'scheduler', loadChildren: './pages/scheduler/scheduler.module#SchedulerModule', canActivate: [AuthenticationGuard] },
            // { path: 'migration', loadChildren: './pages/migration/migration.module#MigrationModule', canActivate: [AuthenticationGuard]},
            // { path: 'dashboard', loadChildren: './pages/storage-selection/storage-selection.module#DashboardModule' },
            // { path: 'volumes', loadChildren: './pages/volumes/volumes.module#VolumesModule'},
            // { path: 'nodes', loadChildren: './pages/nodes/nodes.module#NodesModule'},
            // { path: 'secrets', loadChildren: './pages/secrets/secrets.module#SecretsModule'},
            // { path: 'registry', component: RegistryListComponent},
            // { path: 'grupos', component: GroupComponent},
            // { path: 'info/grupos/:id', loadChildren: './pages/group-details/group-details.module#GroupDetailsModule'},
            // { path: 'permissions/:user/:role/:id/:details', loadChildren: './pages/permissions/permissions.module#PermissionsModule'},
            // { path: 'servicos', loadChildren: './pages/servicos/servicos.module#ServicosModule'},
            // { path: 'tasks', loadChildren: './pages/tasks/tasks.module#TasksModule'},
            // { path: 'deployment/:id/:label', loadChildren: './pages/deployments-details/deployments-details.module#DeploymentsDetailsModule'},
            // { path: 'catalogo', loadChildren: './pages/catalogo/catalogo.module#CatalogoModule'},
            // { path: 'statefulset/:id/:label/:kind', loadChildren: './pages/stateful-details/stateful-details.module#StatefulDetailsModule'},
            // { path: 'deploy-yaml', loadChildren: './pages/deploy-ymal/deploy-yaml.module#DeployYamlModule'},
            // { path: 'daemonsets', loadChildren: './pages/daemonsets/daemonsets.module#DaemonsetsModule'},
            // { path: 'statefulsets', loadChildren: './pages/stateful-sets/stateful-sets.module#StatefulSetsModule'},
            // { path: 'ingress', loadChildren: './pages/ingress/ingress.module#IngressModule'},
            // { path: 'create', loadChildren: './pages/create-deployment/create-deployment.module#CreateDeploymentModule'},
            // { path: 'configuracoes/:id', loadChildren: './pages/configuracoes/configuracoes.module#ConfiguracoesModule'},
            // { path: 'addregistry/:name', loadChildren: './pages/add-registry/add-registry.module#AddRegistryModule'},
            // { path: 'overview', loadChildren: './pages/overview/overview.module#OverviewModule'}
        ]
    },
    {
        path: '', component: BlankLayoutComponent,
        children: [
            { path: 'login', loadChildren: './pages/login/login.module#LoginModule'},
            // { path: 'dashboard', loadChildren: './pages/dashboard/dashboard.module#DashboardModule', canActivate: [AuthenticationGuard] },
        ]
    },
    // { path: 'login', component: LoginComponent},
    // { path: 'dashboard', component: StorageSelectionComponent},
    // Handle all other routes
    // {path: '**',  redirectTo: 'dashboard'}
];
